import { Fragment } from 'react/jsx-runtime';
import Snippet from '../../components/Snippet';
import { links, socials } from './are-copy';

const Are = () => {
  return (
    <Fragment>
      <center>
        {links.map((link, i) => (
          <a
            key={i}
            style={{
              backgroundColor: '#05141f',
              border: 'none',
              color: 'white',
              padding: '15px 32px',
              textAlign: 'center',
              margin: '10px',
              textDecoration: 'none',
              display: 'block',
              fontSize: '16px',
              borderRadius: '2px',
              width: '260px',
            }}
            href={link.href}
            target={link.href.includes('kia.com') ? '_self' : '_blank'}
            className="btn btn--em btn--block-sm"
          >
            {link.text}
          </a>
        ))}
        <br />
        <br />
        <br />
        <br />
        <div style={{ display: 'flex', justifyContent: 'center', gap: '5px' }}>
          {socials.map((social, i) => (
            <a key={i} href={social.href} target="_blank">
              <img
                style={{
                  width: '100px',
                  height: '100px',
                }}
                src={social.icon}
                alt={social.alt}
              />
            </a>
          ))}
        </div>
        <div style={{ height: '100px' }}></div>
      </center>
      <Snippet page="are" />
    </Fragment>
  );
};

export default Are;
